module.exports = "/static/Images/images/Neutral.png";